$(function() {
  //左から
  $('.fade_r').on('inview', function(event, isInView) {
    if (isInView) {
        $(this).addClass('fadeInRight');
    }
  });

  //右から
  $('.fade_l').on('inview', function(event, isInView) {
    if (isInView) {
        $(this).addClass('fadeInLeft');
    }
  });

  //下から
	$('.fade_u').on('inview', function(event, isInView) {
		if (isInView) {
				$(this).addClass('fadeInUp');
		}
	});

  //上から
	$('.fade_d').on('inview', function(event, isInView) {
		if (isInView) {
				$(this).addClass('fadeInDown');
		}
	});

  //バウンド
	$('.bounce_0').on('inview', function(event, isInView) {
		if (isInView) {
				$(this).addClass('bounce');
		}
	});

  //点滅
	$('.flash_0').on('inview', function(event, isInView) {
		if (isInView) {
				$(this).addClass('flash');
		}
	});

  //縮小
  $('.pulse_0').on('inview', function(event, isInView) {
		if (isInView) {
				$(this).addClass('pulse');
		}
	});

  //びよーん
  $('.rubberBand_0').on('inview', function(event, isInView) {
    if (isInView) {
        $(this).addClass('rubberBand');
    }
  });

  //横揺れ
  $('.shake_0').on('inview', function(event, isInView) {
    if (isInView) {
        $(this).addClass('shake');
    }
  });

  //横揺れ　小
  $('.headShake_0').on('inview', function(event, isInView) {
    if (isInView) {
        $(this).addClass('headShake');
    }
  });

  //ブランコ
  $('.swing_0').on('inview', function(event, isInView) {
    if (isInView) {
        $(this).addClass('swing');
    }
  });

  //ぐらぐら
  $('.tada_0').on('inview', function(event, isInView) {
    if (isInView) {
        $(this).addClass('tada');
    }
  });

  //ぐらぐら　2
  $('.wobble_0').on('inview', function(event, isInView) {
    if (isInView) {
        $(this).addClass('wobble');
    }
  });

  //ぐらぐら　3
  $('.jello_0').on('inview', function(event, isInView) {
    if (isInView) {
        $(this).addClass('jello');
    }
  });

  //どくどく
  $('.heartBeat_0').on('inview', function(event, isInView) {
    if (isInView) {
        $(this).addClass('heartBeat');
    }
  });

  //どくどく　2
  $('.bounceIn_0').on('inview', function(event, isInView) {
    if (isInView) {
        $(this).addClass('bounceIn');
    }
  });

  //上から
  $('.bounceInDown_0').on('inview', function(event, isInView) {
    if (isInView) {
        $(this).addClass('bounceInDown');
    }
  });

  //左から
  $('.bounceInLeft_0').on('inview', function(event, isInView) {
    if (isInView) {
        $(this).addClass('bounceInLeft');
    }
  });

  //右から
  $('.bounceInRight_0').on('inview', function(event, isInView) {
    if (isInView) {
        $(this).addClass('bounceInRight');
    }
  });

  //右から
  $('.bounceInUp_0').on('inview', function(event, isInView) {
    if (isInView) {
        $(this).addClass('bounceInUp');
    }
  });

});
